import {
  ERROR_FETCH_AQARAT,
  FETCH_AQARAT,
  SEARCH_AQARAT,
} from '../actions/types';

const initialState = {
  data: [],
  pageNumber: 1,
  pageSize: 0,
  totalElment: 0,
  total_pages: 0,
  loading: true,
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  // console.log('state', payload);
  switch (type) {
    case FETCH_AQARAT:
    case SEARCH_AQARAT:
      return {
        ...state,
        data: payload.data,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize,
        totalElment: payload.totalElment,
        total_pages: payload.total_pages,
        loading: false,
      };
    case ERROR_FETCH_AQARAT:
      console.log('ERROR_FETCH_AQARAT');
      return {
        ...state,
        data: [],
        pageNumber: 1,
        pageSize: 0,
        totalElment: 0,
        total_pages: 0,
        loading: true,
      };
    default:
      return state;
  }
}
